import jqueryWithUI from './src/jquery';

export type AjaxSettings = JQuery.AjaxSettings;
export type DoneCallback = JQuery.jqXHR.DoneCallback;
export type PlainObject = JQuery.PlainObject;

// eslint-disable-next-line import/no-default-export
export default jqueryWithUI;
